import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { BannerService } from '@core/services/banner.service';
import { MessageModule } from 'primeng/message';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-banner',
  imports: [ButtonModule, MessageModule, TranslatePipe],
  templateUrl: './banner.component.html',
})
export class BannerComponent {
  private bannerService = inject(BannerService);

  readonly banners = this.bannerService.banners;

  dismiss(id: string): void {
    this.bannerService.dismiss(id);
  }
}
